






























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

@Component
export default class DatePicker extends Vue {
  @Prop(String) label!: string
  @Prop(Date || String) value!: Date | string
  @Prop(Boolean) disabled?: boolean
  @Prop(Date) min?: Date
  date = new Date(this.value).toISOString().substring(0, 10)
  minDate = this.min?.toISOString()?.substring(0, 10) || ''
  menu = false

  @Watch('date')
  onDateChanged () {
    this.$emit('input', this.date)
  }

  handleInput (value: string) {
    this.date = value
    this.menu = false
  }

  get formattedValue () {
    return new Date(this.value).toLocaleDateString('he-IL')
  }
}
